import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ScWidgetToggleDirective } from './sc-widget-toggle.directive';
import { ScWidgetComponent } from './sc-widget.component';

@NgModule({
  declarations: [ScWidgetComponent, ScWidgetToggleDirective],
  imports: [CommonModule],
  exports: [ScWidgetComponent]
})
export class ScWidgetModule {}
